export enum AssessmentEvents {
  assessmentsActivityViewed = 'Assessments Activity Viewed',
  assessmentChartLineInteraction = 'Assessment Chart Line Interaction',
  assessmentChartScoreTooltipInteraction = 'Assessment Chart Score Tooltip Interaction',
  assessmentIndexMenuItemInteraction = 'Assessment Index Menu Item Interaction',
  resumeAssessmentClicked = 'Resume Assessment clicked',
  completeTogetherAssessmentCardOverdueButtonClicked = 'Complete Together Assessment Card Overdue Button Clicked',
  completeTogetherAssessmentCardApproachingDueButtonClicked = 'Complete Together Assessment Card Approaching Due Button Clicked',
  // Carries Survey Name but no Survey Id by design: the patient-header
  // pathway has only a SurveyName in scope, and sending an id from some
  // pathways would leave a missing id ambiguous between "that pathway" and
  // "tracking bug". Survey Name is a stable enum and joins fine at create time.
  createNewAssessmentClicked = 'Create New Assessment clicked',
  assessmentViewClicked = 'Assessment View clicked',
  deleteAssessmentListItemButtonClicked = 'Delete Assessment List Item Button Clicked',
  overdueIndexListButtonClicked = 'Overdue Index List Button Clicked',
}

export enum AssessmentEventAttribute {
  SurveyId = 'Survey Id',
  SurveyName = 'Survey Name',
  PatientId = 'Patient Id',
  Source = 'Source',
  ResponseExternalId = 'Response External ID',
  UserId = 'User ID',
  InteractionType = 'Interaction Type',
  LineName = 'Line Name',
  DwellMs = 'Dwell Ms',
}

export enum AssessmentEventSource {
  PatientOverviewTab = 'Patient Overview Tab',
  EditPatientNoteForm = 'Edit Patient Note Form',
  AssessmentCards = 'Assessment Cards',
  AssessmentIndexMenu = 'Assessment Index Menu',
  PatientHeaderActionsMenu = 'Patient Header Actions Menu',
  AssessmentCardsTitleButton = 'Assessment Cards Title button',
  AssessmentCardTitleOptionsMenu = 'Assessment Card Title Options Menu',
  AssessmentEmptyStateCard = 'Assessment Empty State Card',
  AssessmentChartDataPoint = 'Assessment Chart Data Point',
  AssessmentCardTitle = 'Assessment Card Title',
  AssessmentListItem = 'Assessment List Item',
  AssessmentList = 'Assessment List',
}

export enum AssessmentEventInteractionType {
  Hover = 'Hover',
  Click = 'Click',
}
